module.exports = __webpack_public_path__ + "img/SES_4069006800.1697d9c5.jpg";